'use strict';

var chunkRPUPLZSU_js = require('./chunk-RPUPLZSU.js');
var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var h=({children:a,type:r,heading:l,headingVariant:s="h2",linkType:t,className:i,...m})=>jsxRuntime.jsxs("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-fact-card ${r} ${i||""}`),...m,children:[jsxRuntime.jsx(chunkRPUPLZSU_js.a,{variant:s,as:r&&r==="blue"?s:"h4",children:l}),(a||t)&&jsxRuntime.jsxs("div",{className:"content",children:[a&&jsxRuntime.jsx("div",{className:"children",children:a}),t&&jsxRuntime.jsx("div",{className:"link-wrapper",children:t})]})]}),f=h;

exports.a = f;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-SWTW5T2P.js.map